import { SortDir } from '__generated__';
import { createContext } from 'react';

// copy/pasted from types/graphql to avoid compile issues when building storybook
// export enum SortDir {
//   ASC = 'ASC',
//   DESC = 'DESC',
// }

export type SortDirType = SortDir;

export interface SortDirection<T = any> {
  prop: T;
  direction?: SortDirType;
}

export interface SortDirectionMap {
  [prop: string]: SortDirType;
}

export interface SortContextProps<T = any> {
  onHeaderClick: (prop: string) => void;
  sorts: SortDirection<T>[];
}

export const SortContext = createContext<SortContextProps>({
  onHeaderClick: () => undefined,
  sorts: [],
});
